function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 48,
    viewBox: "0 0 132 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.901 26.0576L8.18574 39.4155C7.66747 40.3106 8.29568 41.4447 9.30475 41.4447H24.7353C25.7444 41.4447 26.3726 40.3106 25.8543 39.4155L18.139 26.0576C17.6325 25.1828 16.4075 25.1828 15.901 26.0576Z",
    fill: "#133F66",
    style: {
      fill: "#133F66",
      fill: "color(display-p3 0.0745 0.2471 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7088 38.1599L35.3443 26.6692C35.7527 25.9645 35.2579 25.0734 34.4648 25.0734H21.1938C20.4006 25.0734 19.9059 25.9645 20.3143 26.6692L26.9498 38.1599C27.3464 38.8484 28.3122 38.8484 28.7088 38.1599Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6255 26.0131L29.8867 39.4155C29.3684 40.3106 29.9966 41.4447 31.0057 41.4447H46.4873C47.4964 41.4447 48.1246 40.3106 47.6063 39.4155L39.8675 26.0131C39.361 25.1382 38.1359 25.1382 37.6294 26.0131H37.6255Z",
    fill: "#133F66",
    style: {
      fill: "#133F66",
      fill: "color(display-p3 0.0745 0.2471 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6985 7.62881L18.673 21.5375C18.1783 22.3962 18.779 23.5019 19.7449 23.5019H35.9215C36.8913 23.5019 37.4881 22.3962 36.9934 21.5375L28.9404 7.62881C28.4575 6.7904 27.1814 6.7904 26.6985 7.62881Z",
    fill: "#7AA5C6",
    style: {
      fill: "#7AA5C6",
      fill: "color(display-p3 0.4784 0.6471 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1672 22.5238L66.6902 24.0475C66.6013 24.1392 66.6013 24.288 66.6902 24.3797L68.1672 25.9033C68.2562 25.9951 68.4003 25.9951 68.4893 25.9033L69.9663 24.3797C70.0552 24.288 70.0552 24.1392 69.9663 24.0475L68.4893 22.5238C68.4003 22.4321 68.2562 22.4321 68.1672 22.5238Z",
    fill: "#133F66",
    style: {
      fill: "#133F66",
      fill: "color(display-p3 0.0745 0.2471 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3264 29.8082V22.9673C62.3264 22.8133 62.3343 22.5096 62.346 22.0478C62.35 21.898 62.3539 21.7481 62.3617 21.5902C62.2871 21.8777 62.2165 22.1369 62.1497 22.3759C62.0123 22.8701 61.9024 23.2589 61.816 23.5383L59.845 29.8082H58.0742L56.1031 23.5383L55.5456 21.5335C55.5535 21.7238 55.5613 21.902 55.5692 22.06C55.5849 22.465 55.5927 22.7647 55.5927 22.9673V29.8082H53.3625V18.4836H56.5822L58.5375 24.7696C58.6239 25.122 58.7142 25.4703 58.8084 25.8187C58.8634 26.0333 58.9183 26.2439 58.9733 26.4546C58.989 26.3898 59.1264 25.8713 59.1814 25.6688C59.2364 25.4703 59.2913 25.2719 59.3463 25.0775L61.3566 18.4836H64.5644V29.8082H62.3343H62.3264Z",
    fill: "#133F66",
    style: {
      fill: "#133F66",
      fill: "color(display-p3 0.0745 0.2471 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.103 29.8001V18.4836H79.8693V20.5047H74.5845V29.8001H72.103Z",
    fill: "#133F66",
    style: {
      fill: "#133F66",
      fill: "color(display-p3 0.0745 0.2471 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3967 29.8082V18.4836H86.3596C87.6749 18.4836 88.7036 18.8036 89.4182 19.4273C90.1367 20.0591 90.5019 20.9624 90.5019 22.1086C90.5019 22.8457 90.337 23.5059 90.0072 24.077C89.6774 24.6481 89.2062 25.0977 88.6015 25.4177C88.0008 25.7377 87.2744 25.8997 86.4499 25.8997H83.8781V29.8082H81.3928H81.3967ZM86.1711 23.8867C86.764 23.8867 87.2234 23.7368 87.5375 23.4411C87.8516 23.1455 88.0087 22.7121 88.0087 22.1491C88.0087 21.0474 87.3883 20.5128 86.1122 20.5128H83.886V23.8867H86.1751H86.1711Z",
    fill: "#133F66",
    style: {
      fill: "#133F66",
      fill: "color(display-p3 0.0745 0.2471 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7333 29.9621C93.3603 29.9621 92.9873 29.9135 92.6261 29.8204C92.2609 29.7272 91.9625 29.6097 91.7387 29.472L91.6641 29.4275L92.3591 27.2849L92.4729 27.3416C92.9088 27.5522 93.3093 27.6615 93.6509 27.6615C93.8707 27.6615 94.0592 27.617 94.2162 27.5319C94.3733 27.4469 94.5225 27.3051 94.6678 27.1067C94.8091 26.9001 95.0133 26.5113 95.2685 25.9442L90.9377 18.4836H93.5527L96.4503 23.7004L98.6766 18.4836H101.217L97.1139 27.2403C96.7605 28.0018 96.4307 28.5648 96.1323 28.9171C95.826 29.2817 95.4766 29.549 95.0997 29.715C94.7227 29.8811 94.2634 29.9662 93.7412 29.9662L93.7333 29.9621Z",
    fill: "#133F66",
    style: {
      fill: "#133F66",
      fill: "color(display-p3 0.0745 0.2471 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.219 29.8082V20.6302H104.696V29.8082H102.218V18.4836H111.626V29.8082H109.219Z",
    fill: "#133F66",
    style: {
      fill: "#133F66",
      fill: "color(display-p3 0.0745 0.2471 0.4000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9 29.8082V20.6302H116.373V29.8082H113.899V18.4836H123.307V29.8082H120.9Z",
    fill: "#133F66",
    style: {
      fill: "#133F66",
      fill: "color(display-p3 0.0745 0.2471 0.4000)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1e5fda2201f52996e8c7ca941eccbf78.svg";
export { ForwardRef as ReactComponent };